/* React */
import React from "react";

/* Stylesheet */
import styles from "./ForbiddenContainer.module.scss";

const ForbiddenContainer: React.FC = () => {
  return (
    <div className={styles.forbidden_container}>
      <h1 className={styles.title}>403 Forbidden</h1>
      <p>
        You do not have permission to access this resource.
      </p>
      <p>
        Please contact your administrator if you believe
        this is an error.
      </p>
    </div>
  );
};

export default ForbiddenContainer;
